import {
  Component,
  HostListener,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TranslationService } from '@core/services/translation.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BaseComponent } from 'src/app/base.component';
import { PrintLabelModalService } from './print-label-modal.service';
import {
  GetAllLabelType,
  GetPriceLevelData,
  GetProductsById,
} from './print-label-modal';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
if (pdfMake && pdfFonts && pdfMake.hasOwnProperty('vfs')) {
  if (pdfMake.vfs.hasOwnProperty('pdfFonts')) {
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
  }
}

@Component({
  selector: 'app-print-label-modal',
  templateUrl: './print-label-modal.component.html',
  styleUrls: ['./print-label-modal.component.scss'],
})
export class PrintLabelModalComponent extends BaseComponent implements OnInit {
  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler() {
    this.closePrintLabelModal();
  }
  @ViewChild('printLabelModal') private printLabelModal: TemplateRef<any>;
  private modalRef: BsModalRef;
  public printLabelForm: FormGroup = <FormGroup>{};
  priceLevelOptions: GetPriceLevelData[] = [];
  orderId: string = '';
  labelType: GetAllLabelType[] = [];
  dataSource: GetProductsById[] = [];
  displayedColumns: string[] = ['itemId', 'itemName'];

  constructor(
    private modalService: BsModalService,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    public translationService: TranslationService,
    private printlabelService: PrintLabelModalService
  ) {
    super(translationService);
    this.getLangDir();
  }

  ngOnInit(): void {
    this.createForm();
    this.route.params.subscribe((orderId) => {
      if (orderId && Object.keys(orderId).length > 0 && orderId['id']) {
        this.orderId = orderId['id'];
      }
    });
    this.getProductsById();
    this.getPriceLevelData();
    this.getAllLabelTypes();
  }

  private createForm(): FormGroup {
    return (this.printLabelForm = this.formBuilder.group({
      priceLabel: new FormControl('', [Validators.required]),
      labelType: new FormControl('', [Validators.required]),
    }));
  }

  open() {
    setTimeout(() => {
      this.modalRef = this.modalService.show(this.printLabelModal, {
        backdrop: 'static',
        class: 'modal-dialog-centered overflow-auto payment-ngbModal-window',
      });
    }, 500);
  }

  public closePrintLabelModal(value: boolean = false): void {
    if (this.modalRef) {
      this.printLabelForm.reset();
      this.printLabelForm.updateValueAndValidity();
      this.modalRef.hide();
    }
  }

  private getProductsById() {
    this.printlabelService
      .getProductById(this.orderId)
      .subscribe((res: GetProductsById[]) => {
        if (res && res.length > 0) {
          this.dataSource = res;
        }
      });
  }

  compareFn(obj1: any, obj2: any) {
    return obj1 && obj2 ? obj1.id === obj2.id : obj1 === obj2;
  }

  getPriceLevelData() {
    this.printlabelService
      .getPriceLevelData()
      .subscribe((res: GetPriceLevelData[]) => {
        if (res && res.length > 0) {
          this.priceLevelOptions = res;
        }
      });
  }

  getAllLabelTypes() {
    this.printlabelService
      .getAllLabelTypes()
      .subscribe((res: GetAllLabelType[]) => {
        if (res && res.length > 0) {
          this.labelType = res;
        }
      });
  }

  printLabes() {
    const documentDefinition = {
      content: [
        { text: 'Details', style: 'header', bold: true },
        '',

        `Price Level: ${this.printLabelForm.get('priceLabel').value['name']}`,

        `Label Type: ${this.printLabelForm.get('labelType').value['name']}`,

        { text: 'List Of Items', style: 'header' },
        this.table(this.dataSource, ['productNumber', 'itemName']),
      ],
    };
    pdfMake.createPdf(documentDefinition).download();
    this.printLabelForm.reset();
    this.printLabelForm.updateValueAndValidity();
    this.modalRef.hide();
  }

  private buildTableBody(data: GetProductsById[], columns) {
    let body = [];
    const modifiedColumn = ['Item Id', 'Item Name'];
    body.push(modifiedColumn);

    data.forEach((row) => {
      var dataRow = [];
      columns.forEach((column) => {
        dataRow.push(row[column].toString());
      });
      body.push(dataRow);
    });
    return body;
  }

  private table(data: GetProductsById[], columns) {
    return {
      style: 'tableExample',
      table: {
        heaheaderRows: 1,
        body: this.buildTableBody(data, columns),
      },
    };
  }
}
